<template>
  <div>
    <!-- 하드웨어 정보 -->
    <w-hardware-info-view class="mr-b25" :data="data" />
    <!-- 시스템 로그 -->
    <w-syslog-table class="mr-b25" :data="data" />
    <!-- 인터페이스 -->
    <w-interface-table class="mr-b25" :data="data"/>
    <!-- 전력 -->
    <w-port-power-table class="mr-b25" :data="data"/>
    <!-- 무선 AP -->
    <w-wireless-ap-table class="mr-b25" :data="data" />
    <!-- 컨피그 변경 -->
    <w-config-change-hist-view :data="data" />
  </div>
</template>

<script>
import WHardwareInfoView from './HardwareInfoView';
import WSyslogTable from './SyslogTable';
import WInterfaceTable from './InterfaceTable';
import WConfigChangeHistView from './ConfigChangeHistView';
import WPortPowerTable from './PortPowerTable';
import WWirelessApTable from './WirelessApTable';

export default {
  name: 'WNetdeviceEtcInfoView',
  components: {
    WHardwareInfoView,
    WSyslogTable,
    WInterfaceTable,
    WConfigChangeHistView,
    WWirelessApTable,
    WPortPowerTable,
  },
  props: {
    /**
     * 기타 분석 정보 조회 시 필요한 정보 객체 (동시성 문제 고려하여 하나의 객체로 전달)
     * 1) obj: 분석 대상 장비 정보
     * 2) eventHistData: 분석 이벤트 이력 정보
     * 3) etcInfo: 기타 분석 정보
     * @type {Object}
     */
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/popup/FaultAnalysisPopup/components/FaultAnalysisInfoView/EtcInfo/NetdeviceEtcInfoView/index.vue